<template>
  <mdb-container v-if="loggedIn" class="gp-has-header">
    <h3>Personal Calendar For {{ userDetails.name }}</h3>
    <div id="tooltip" style="display:none"></div>
    <div class="top-buttons">
      <mdb-btn floating icon="print" size="sm" tag="a" title="Print" @click="print"/>
    </div>
    <full-calendar :draggable="false"
                   :editable="false"
                   :event-limit="true"
                   :events="events"
                   :event-time-format="userTimeFormat"
                   :first-day="userDetails.mondayFirst ? 1 : 0"
                   :header="header"
                   :nav-links="true"
                   :plugins="calendarPlugins"
                   :views=views
                   :weekends=true
                   defaultView="dayGridMonth"
                   @eventMouseEnter="mouseEnter"
                   @eventMouseLeave="mouseExit"
    />
    <div>You can subscribe to your personal calendar on Google, iCal and others via a link <router-link to="/user/profile?tab=calendar">from your profile</router-link>.</div>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'

import {mdbBtn, mdbContainer} from 'mdbvue';

import fullCalendar from "@fullcalendar/vue"
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list';

export default {
  name: "user-calendar",
  display: "User Calendar",
  order: 1,
  components: {
    mdbContainer,
    mdbBtn,
    fullCalendar
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
    userDetails() {
      return this.$store.state.userDetails
    },
    userTimeFormat() {
      let ret = { hour: 'numeric',minute: '2-digit', meridiem: 'short'}
      if (this.userDetails.timeFormat == "24 Hour") ret = { hour: '2-digit',minute: '2-digit', meridiem: false, hour12: false}
      return ret
    }

  },
  data() {
    return {
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'a dayGridMonth,a dayGridWeek,a dayGridDay, a listMonth'
      },
      views: ['dayGridMonth', 'dayGridWeek'],
      events: (info, success, failure) => {
        let url = "/user/calendar/?start=" + info.startStr + "&end=" + info.endStr
        this.$store.dispatch("setExecuting", true)
        api.get(url).then(
          (details) => {
            success(details.data)
          },
          (error) => {
            this.$notify.error({message: "Error getting calendar data."})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      calendarPlugins: [dayGridPlugin, listPlugin]
    }
  },
  mounted() {
    document.title = "My Calendar"
  },
  methods: {
    mouseEnter: function (data) {
      if (document.documentElement.clientWidth < 1024) return
      let tip = document.getElementById("tooltip")
      tip.innerHTML = data.el.innerText
      tip.style.position = "absolute"
      tip.style.left = data.jsEvent.pageX - 200 + "px"
      tip.style.top = data.jsEvent.pageY - 80 + "px"
      tip.style.display = "block"
      tip.style.backgroundColor = data.event.backgroundColor

    },
    mouseExit: function (data, event, view) {
      if (document.documentElement.clientWidth < 1024) return
      let tip = document.getElementById("tooltip")
      tip.style.display = "none"
    },
    print: function () {
      window.print()
    }
  }

};
</script>

<style lang='scss'>
@import '@fullcalendar/core/main.css';
@import '@fullcalendar/daygrid/main.css';
@import '@fullcalendar/list/main.css';

#tooltip {
  width: auto;
  height: auto;
  z-index: 10001;
  padding: 10px 10px 10px 10px;
  line-height: 200%;
  color: #ffffff;
}

@media screen and (min-width: 750px) {
  .top-buttons {
    top: 0;
    position: absolute;
    right: 0;
    padding-top: 80px;
    padding-right: 20px;
  }
}

@media screen and (max-width: 749px) {
  .top-buttons {
    display: none;
  }
}

</style>
